import { DataTable, DataTablePagination } from "@/components/DataTable";
import { useCertificationsTable } from "../-hooks/useCertificationsTable";

export const CertificationsDataTable = ({
  personId,
}: { personId?: string }) => {
  const { table, displayState } = useCertificationsTable(personId);

  return (
    <>
      <div className="overflow-auto flex-1 min-h-0">
        <DataTable table={table} displayState={displayState} />
      </div>
      <DataTablePagination table={table} />
    </>
  );
};
